/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetEventAttendeeForUserQueryVariables = Types.Exact<{
  user_id: Types.Scalars["Int"];
  event_id: Types.Scalars["Int"];
}>;

export type GetEventAttendeeForUserQuery = {
  eventAttendees: Array<Pick<Types.EventAttendee, "id" | "has_id">>;
};

export const GetEventAttendeeForUserDocument = gql`
  query GetEventAttendeeForUser($user_id: Int!, $event_id: Int!) {
    eventAttendees(
      where: {
        user_id: { equals: $user_id }
        event_id: { equals: $event_id }
        role: { equals: "hacker" }
      }
    ) {
      id
      has_id
    }
  }
`;

/**
 * __useGetEventAttendeeForUserQuery__
 *
 * To run a query within a React component, call `useGetEventAttendeeForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAttendeeForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAttendeeForUserQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetEventAttendeeForUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetEventAttendeeForUserQuery,
    GetEventAttendeeForUserQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetEventAttendeeForUserQuery,
    GetEventAttendeeForUserQueryVariables
  >(GetEventAttendeeForUserDocument, baseOptions);
}
export function useGetEventAttendeeForUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetEventAttendeeForUserQuery,
    GetEventAttendeeForUserQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetEventAttendeeForUserQuery,
    GetEventAttendeeForUserQueryVariables
  >(GetEventAttendeeForUserDocument, baseOptions);
}
export type GetEventAttendeeForUserQueryHookResult = ReturnType<
  typeof useGetEventAttendeeForUserQuery
>;
export type GetEventAttendeeForUserLazyQueryHookResult = ReturnType<
  typeof useGetEventAttendeeForUserLazyQuery
>;
export type GetEventAttendeeForUserQueryResult = ApolloReactCommon.QueryResult<
  GetEventAttendeeForUserQuery,
  GetEventAttendeeForUserQueryVariables
>;
